import { createSlice } from "@reduxjs/toolkit"

// https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
// the modern version of the Fisher–Yates shuffle algorithm:
function shuffle(a) {
  let j, x, i
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1))
    x = a[i]
    a[i] = a[j]
    a[j] = x
  }
  return a
}

export const slice = createSlice({
  name: "test",
  initialState: {
    current: 0,
    type: "",
    path: "",
    quiz_id: "",
    questions: [
      {
        correct: false,
        selectedOp: [],
        content: "",
        category: "",
        img: "",
        explanation: "",
        options: [
          {
            content: "",
            img: "",
            correct: false,
          },
        ],
      },
    ],
    finished: false,
    progress: [{ current: -1, checkedOptionsSet: [] }],
  },
  reducers: {
    setQuiz: (state, action) => {
      if (
        typeof window !== "undefined" &&
        window.localStorage.getItem(action.payload.path) &&
        window.localStorage.getItem(action.payload.path).includes("inProgress")
      ) {
        let contineudQuiz =
          typeof window !== "undefined" &&
          JSON.parse(window.localStorage.getItem(action.payload.path))
            .inProgress

        state.current = contineudQuiz.current
        state.type = contineudQuiz.type
        state.path = contineudQuiz.path
        state.quiz_id = contineudQuiz.quiz_id
        state.questions = contineudQuiz.questions
        state.progress = contineudQuiz.progress
      } else {
        state.type = action.payload.type
        state.path = action.payload.path
        state.quiz_id = action.payload.quiz_id
        state.progress = new Array(action.payload.questions.length).fill({
          current: -1,
          checkedOptionsSet: [],
        })
        let questions = [...action.payload.questions]

        for (let i = 0; i < questions.length; i++) {
          let question = { ...questions[i] }
          let options = [...question.options]
          question.options = shuffle(options)
          questions[i] = question
        }
        state.questions = shuffle(questions)
      }
    },
    setCurrent: (state, action) => {
      if (action.payload < state.questions.length) {
        state.current = action.payload
      }
    },
    setAnswered: (state, action) => {
      state.questions[state.current].answered = action.payload
    },
    setCorrect: (state, action) => {
      state.questions[state.current].correct = action.payload
    },
    setSelectedOp: (state, action) => {
      state.questions[state.current].selectedOp = action.payload
    },
    setProgress: (state, action) => {
      state.progress[action.payload.current] = action.payload
    },
    setFinished: (state, action) => {
      state.finished = action.payload
    },
    restart: (state, action) => {
      state.current = 0
      state.finished = false
      state.type = action.payload.type
      state.path = action.payload.path
      state.quiz_id = action.payload.quiz_id
      let questions = [...action.payload.questions]

      for (let i = 0; i < questions.length; i++) {
        let question = { ...questions[i] }
        let options = [...question.options]
        question.options = shuffle(options)
        questions[i] = question
      }
      state.questions = shuffle(questions)
    },
    reset: state => {
      state.current = 0
      state.type = ""
      state.path = ""
      state.quiz_id = ""
      state.questions = [
        {
          correct: false,
          selectedOp: [],
          content: "",
          category: "",
          img: "",
          explanation: "",
          options: [
            {
              content: "",
              img: "",
              correct: false,
            },
          ],
        },
      ]
      state.progress = [{ current: -1, checkedOptionsSet: [] }]
      state.finished = false
    },
  },
})

export const selectCurrentQuestion = state =>
  state.test.questions[state.test.current]
export const selectCurrent = state => state.test.current
export const selectType = state => state.test.type
export const selectPath = state => state.test.path
export const selectQuizID = state => state.test.quiz_id
export const selectQuestions = state => state.test.questions
export const selectFinished = state => state.test.finished
export const selectTest = state => state.test
export const selectProgress = state => state.test.progress

export const {
  setQuiz,
  setCurrent,
  setAnswered,
  restart,
  setFinished,
  setCorrect,
  setSelectedOp,
  reset,
  setProgress,
} = slice.actions

export default slice.reducer